export var ProducerConditionType;
(function (ProducerConditionType) {
    /**
     * Recorder does not have a recording schedule, thus we do not monitor it.
     */
    ProducerConditionType["NotMonitored"] = "not_monitored";
    /**
     * Recorder is scheduled to be recording, but is not.
     */
    ProducerConditionType["NotRecordingWhileInSchedule"] = "not_recording_while_in_schedule";
    /**
     * Recorder is offline, but it's supposed to be online.
     */
    ProducerConditionType["NotHeartbeating"] = "not_heartbeating";
    /**
     * The primary audio device is not available, we cannot stream/record
     */
    ProducerConditionType["AudioDeviceUnavailable"] = "audio_device_unavailable";
    /**
     * Usually a warning, a video device has disconnected
     */
    ProducerConditionType["VideoDeviceUnavailable"] = "video_device_unavailable";
    /**
     * Streaming infrastructure is broken
     */
    ProducerConditionType["StreamingServerError"] = "streaming_server_error";
    /**
     * Generic Recorder infrastructure or config problem, such as not whitelisting EC2
     */
    ProducerConditionType["RecorderConfigError"] = "recorder_config_error";
    /**
     * Recorder has had many recent failed sessions, is likely crash looping
     */
    ProducerConditionType["CrashLoop"] = "crash_loop";
    /**
     * The upgrade process has started
     */
    ProducerConditionType["Upgrading"] = "upgrading";
    /**
     * The timezone does not match the courthouses timezone
     */
    ProducerConditionType["MismatchedTimezone"] = "mismatched_timezone";
    /**
     * The time on the recording PC is not synced with an NTP server
     */
    ProducerConditionType["ClockNotInSync"] = "clock_not_in_sync";
    /**
     * There is low disk space remaining to record
     */
    ProducerConditionType["LowDiskSpace"] = "low_disk_space";
    /**
     * There is no disk space remaining to record
     */
    ProducerConditionType["NoDiskSpace"] = "no_disk_space";
})(ProducerConditionType || (ProducerConditionType = {}));
